import { render, staticRenderFns } from "./H5Game.vue?vue&type=template&id=4677b96a&scoped=true&"
import script from "./H5Game.vue?vue&type=script&lang=js&"
export * from "./H5Game.vue?vue&type=script&lang=js&"
import style1 from "./H5Game.vue?vue&type=style&index=1&id=4677b96a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4677b96a",
  null
  
)

export default component.exports